import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { UPDATE_DMX_PROFILE } from './actionTypes';
import { updateDmxProfileSuccessful, updateDmxProfileFailed } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* updateProfile({ payload: { profile } }) {
  try {
    const response = yield call(dmxAPI.updateProfile, profile.token, profile.id, profile);
    if (response.message) {
      yield put(updateDmxProfileSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(updateDmxProfileFailed(error));
  }
}

export function* watchUpdateDmxProfile() {
  yield takeEvery(UPDATE_DMX_PROFILE, updateProfile);
}

function* updateDmxProfileSaga() {
  yield all([fork(watchUpdateDmxProfile)]);
}

export default updateDmxProfileSaga;
